import { render, staticRenderFns } from "./speech-recognition.vue?vue&type=template&id=1d101980&scoped=true&"
import script from "./speech-recognition.js?vue&type=script&lang=js&"
export * from "./speech-recognition.js?vue&type=script&lang=js&"
import style0 from "./speech-recognition.css?vue&type=style&index=0&id=1d101980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d101980",
  null
  
)

export default component.exports